if (!customElements.get('gs-pdp-offer-selector')) {
  customElements.define('gs-pdp-offer-selector', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.root = this.closest('[data-section-type="product"]');
      if (!this.root) return;
      const productBlocks = this.root.querySelector('[data-product-blocks]');
      const nativeForm = this.root.querySelector('form.product-single__form');
      const nativeFormBlock = productBlocks && nativeForm ? [...productBlocks.children].find(block => block.contains(nativeForm)) : null;
      const nativePickerBlocks = productBlocks ? [...productBlocks.children].filter(block => block.matches('.gs-preview-picker') || !!block.querySelector('.variant-wrapper,.variant-input-wrap,[data-variant-input]')) : [];
      [...new Set([...nativePickerBlocks, nativeFormBlock].filter(Boolean))].forEach(block => block.setAttribute('data-gs-single-only', ''));
      this.root.dataset.gsOfferMode = 'single';
      this.root.addEventListener('gs:offer-target', event => this.select(event.detail.target));
      this.addEventListener('click', async event => {
        const button = event.target.closest('[data-gs-offer]');
        if (!button || !this.contains(button)) return;
        const target = Number(button.dataset.target);
        this.querySelector('[role="alert"]').hidden = true;
        if (target === 1) {
          this.select(1);
          const builder = this.root.querySelector('gs-bundle-builder');
          if (builder?.inline) builder.inline.hidden = true;
          this.root.dataset.gsOfferMode = 'single';
          return;
        }
        const builder = this.root.querySelector('gs-bundle-builder[data-offer-pilot="true"]');
        if (!builder?._ready || typeof builder.configureOffer !== 'function') {
          const error = this.querySelector('[role="alert"]');
          error.textContent = this.dataset.unavailable;
          error.hidden = false;
          return;
        }
        await builder.expandOffer(target);
        this.select(builder.targetCount);
      });
    }
    select(target) {
      if (this.root) this.root.dataset.gsOfferMode = target > 1 ? 'pack' : 'single';
      this.querySelectorAll('[data-gs-offer]').forEach(button => {
        const active = Number(button.dataset.target) === target;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        if (button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', String(active && target > 1));
      });
    }
  });
}
